import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ConfigService } from '../../shared-services/config.service';
import { FilterDialogComponent } from '../filter-dialog/filter-dialog.component';

@Component({
  selector: 'app-spriced-filter-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    NgxMatSelectSearchModule,
  ],
  templateUrl: './spriced-filter-dialog.component.html',
  styleUrls: ['./spriced-filter-dialog.component.scss'],
})
export class SpricedFilterDialogComponent extends FilterDialogComponent {
  constructor(
    dialogRef: MatDialogRef<SpricedFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    fb: FormBuilder,
    configService: ConfigService,
  ) {
    super(dialogRef as unknown as MatDialogRef<FilterDialogComponent>, data, fb, configService);
  }
}
